export const PriceTypesEnum = Object.freeze({
    PER_MT : "Per MT",
    LUMPSUM : "Lumpsum",
});